import React from "react";
import { ProductItem } from "@swo/storefront";
import { css } from "@emotion/react";
import { IntendedUseCard } from "../IntendedUseCard";
import { unlabeledInternalLinkOf } from "../../../domain/swarovski-optik/links";
import { ContentfulImage2 } from "../../../components/_shared-components/image-related/ContentfulImage2";
import { PLPCard } from "../../product-listing-page/ProductListingPageFamiliesTiles/PLPCard";
import { PLPContent } from "../../product-listing-page/ProductListingPageFamiliesTiles/PLPContent";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { nonEmpty } from "@swo/shared";
import { CSS_MQ } from "../../../styles/breakpoints";

export const IntendedUseProductItemCard: React.FC<{
  card: ProductItem;
}> = ({ card }) => {
  const link = unlabeledInternalLinkOf({
    pathname: card.link,
  });

  const subheadlines: Array<{ name: string; isNew: boolean }> = [];
  //  [
  //   card.lowestPrice
  //     ? {
  //         isNew: false,
  //         name: card.lowestPrice,
  //       }
  //     : undefined,
  // ].filter(nonEmpty);

  return (
    <IntendedUseCard link={link} hasBorderRadius={true}>
      <div
        className="u-grow so-color-green"
        css={css`
          display: grid;
          grid-template-rows: 1fr auto;
          grid-auto-flow: row;

          position: relative;
          ${CSS_MQ.atLeastSm} {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          padding: 20px;
          ${CSS_MQ.atLeastSm} {
            padding: 24px;
          }

          --secondary-text-color: ${CSS_COLORS.Black};
          &:hover {
            background-color: ${CSS_COLORS.GreenWhite};
          }
        `}
      >
        <PLPContent headline={card.name} isNew={!!card.isNew} subheadlines={subheadlines} asset={card.image?.url} />
      </div>
    </IntendedUseCard>
  );
};
